import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AssetSummarySchema = withDefaults({
  type: 'asset-summary',
  objectExtensions: ['asset-summary'],
  fields: [
    {
      kind: 'attribute',
      name: 'assetType',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'etag',
    },
    {
      kind: 'attribute',
      name: 'quickSummary',
    },
    {
      kind: 'attribute',
      name: 'summary',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'digitalAsset',
      type: 'digital-asset',
      options: {
        async: false,
        inverse: 'assetSummary',
        polymorphic: true,
      },
    },
  ],
});

export default AssetSummarySchema;
